import {
  getFinalCentimeterConversion,
  getFinalFeetConversion,
  getFinalInchesConversion,
  getFinalKilometersConversion,
  getFinalMetersConversion,
  getFinalMilesConversion,
  getFinalYardsConversion
} from "./LengthConversionTracker";

function getConversion(temp, conType) {
  let result = "";
  switch (conType.slice(0, 2)) {
    case "ft":
      result = getFinalFeetConversion(temp, conType);
      break;
    case "cm":
      result = getFinalCentimeterConversion(temp, conType);
      break;
    case "in":
      result = getFinalInchesConversion(temp, conType);
      break;
    case "kl":
      result = getFinalKilometersConversion(temp, conType);
      break;
    case "mt":
      result = getFinalMetersConversion(temp, conType);
      break;
    case "mi":
      result = getFinalMilesConversion(temp, conType);
      break;
    case "yd":
      result = getFinalYardsConversion(temp, conType);
      break;
    default:
      result = "";
  }

  return result;
}

export { getConversion };
